import _Vue from 'vue';
import Axios, { AxiosAdapter, AxiosRequestConfig } from 'axios';
import { cacheAdapterEnhancer } from 'axios-extensions';

const adapter = Axios.defaults.adapter as AxiosAdapter;
const config: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_BASE_URL,
  adapter: cacheAdapterEnhancer(adapter, { enabledByDefault: false }),
};

const signalRConfig: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_SIGNALR_URL,
  adapter: cacheAdapterEnhancer(adapter, { enabledByDefault: false }),
};

// export type PluginFunction<T> = (Vue: typeof _Vue, options?: T) => void;
export function AxiosPlugin(Vue: typeof _Vue): void {
  // do stuff with options

  Vue.prototype.$http = Axios.create(config);
  Vue.prototype.$signalr = Axios.create(signalRConfig);
}

export class AxiosPluginOptions {}
